var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{ref:"iframe",attrs:{"src":_vm.src,"width":"100%","height":_vm.iframeHeight}})])
}
var staticRenderFns = []

export { render, staticRenderFns }